import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import MaterialTable from "material-table";


const FBRViewProduct = (props) => {

    useEffect(() => {
        props.setHeading("Product List");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    title="Product List"
                    columns={[
                        { title: 'SR No.', field: 'sequenceNumber' },
                        { title: 'Company Name', field: 'companyId.companyName' },
                        { title: 'Product Name', field: 'name' },
                        { title: 'Unit Price', field: 'unitPrice' },
                        { title: 'Sale Tax', field: 'saleTax' },
                        // { title: 'Extra Tax', field: 'extraTax' },
                        { title: 'HS Code', field: 'HSCode' },
                        { title: 'UOM', field: 'uom' },
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky", top: 0,
                            color: "#00BBBB", fontWeight: "550",
                            onRowAdd: "none", whiteSpace: "nowrap",
                        },
                        rowStyle: { whiteSpace: "nowrap" },
                        cellStyle: {
                            whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                        },
                    }}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/FBRInvoice/get-products?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + query.page;
                            url += "&search=" + query.search;
                            fetch(url, { method: "GET", headers }).then((res) => res.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.totalResults,
                                });
                            });
                        })
                    }
                />
            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    setHeading: (data) => dispatch(setHeading(data)),
});

const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(FBRViewProduct);